export default "__VITE_ASSET__DGV0qJ45__"